export default "__VITE_ASSET__xhKEcCqi__"